import Vue from 'vue'
import VueRouter from 'vue-router'
import pageLoadAnimationBus from '../pageLoadAnimationBus'
import homeOutAnimationBus from '../homeOutAnimationBus'
import Home from '../views/Home.vue'
import Admin from '../views/Admin.vue'
// import firebase from '../firebaseinit'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/contact',
    name: 'Contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "contact" */ '../views/Contact.vue')
    }
  },
  {
    path: '/team',
    name: 'Team',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Team.vue')
    }
  },
  {
    path: '/work',
    name: 'Work',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "work" */ '../views/Work.vue')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach(async (to, from, next) => {
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
//   if (requiresAuth && !await firebase.getCurrentUser()) {
//     next({ name: 'Login', params: { from: to.fullPath } })
//   } else {
//     next()
//   }
// })

router.beforeEach((to, from, next) => {
  if (to.name === 'Home') {
    pageLoadAnimationBus.setShouldHomeLoaderRun(from.name === null)
    homeOutAnimationBus.setShouldResetRun(from.name !== null)
  } else {
    pageLoadAnimationBus.setShouldHomeLoaderRun(false)
    homeOutAnimationBus.setShouldResetRun(false)
  }
  next()
})

export default router
